// eslint-disable-next-line import/prefer-default-export
export const loadImage = (src: string) => {
  const img = new Image();
  img.src = src;
};
